import styled from "styled-components";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";

export const GenericSideMenuLabelDefaultBox = styled.span`
    flex: 1 0 auto;
`;

export const GenericSideMenuLabelBox = styledByTheme(GenericSideMenuLabelDefaultBox)
    .apply();
